export default __webpack_public_path__ + "static/media/5.c4db6d9f.png";